import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    myLobby: {},
    errors: {}
};

getters['fetchMyLobby'] = function(state) { return state.myLobby }

const actions = {
    create(context, payload) {
        return ApiService
            .post('games/create_lobby/', payload, false) // Отключаем автоматический показ ошибки
            .then((response) => {
                context.commit('SET_MY', response.data);
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    invite(context, payload) {
        return ApiService
            .get('games/lobby/invite/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    join(context, payload) {
        return ApiService
            .get('games/lobby/' + payload + '/join/')
            .then((response) => {
                context.commit('SET_MY', response.data);
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
}

const mutations = {    
    SET_MY(state, myLobby) {
        state.myLobby = myLobby;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
